"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Input = _interopRequireDefault(require("../../Input"));
var _Select = _interopRequireDefault(require("../../Select"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["NEXT_PAGE"] = "Next page";
  Label["PREVIOUS_PAGE"] = "Previous page";
  Label["PAGE_NUMBER"] = "Page number";
  return Label;
}({});
const TablePaginationControls = _ref => {
  let {
    className,
    currentPage,
    description,
    displayDescription = true,
    onInputPageChange,
    itemName,
    nextButtonProps,
    onNextPage,
    onPageChange,
    onPageSizeChange,
    onPreviousPage,
    pageLimits,
    pageSize,
    previousButtonProps,
    showPageInput = true,
    totalItems,
    visibleCount,
    ...divProps
  } = _ref;
  const isSmallScreen = (0, _utils.useFigureSmallScreen)();
  const totalPages = totalItems ? Math.ceil(totalItems / pageSize) : null;
  const descriptionDisplay = (0, _utils.getDescription)({
    description,
    visibleCount,
    isSmallScreen,
    totalItems,
    itemName
  });
  const handleDecrementPage = currentPage => {
    if (currentPage > 1) {
      onPageChange === null || onPageChange === void 0 || onPageChange(currentPage - 1);
    }
    onPreviousPage === null || onPreviousPage === void 0 || onPreviousPage(typeof currentPage === "number" ? currentPage - 1 : null);
  };
  const handleIncrementPage = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      onPageChange === null || onPageChange === void 0 || onPageChange(currentPage + 1);
    }
    onNextPage === null || onNextPage === void 0 || onNextPage(typeof currentPage === "number" ? currentPage + 1 : null);
  };
  const handleInputPageChange = e => {
    const newPage = Math.min(totalPages, Math.max(1, parseInt(e.target.value)));
    onPageChange === null || onPageChange === void 0 || onPageChange(newPage);
    onInputPageChange === null || onInputPageChange === void 0 || onInputPageChange(Number(e.target.value));
  };
  const handlePageSizeChange = e => {
    onPageSizeChange(parseInt(e.target.value));
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("pagination", className)
  }, divProps, {
    role: "navigation"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "description",
    id: "pagination-description"
  }, displayDescription ? descriptionDisplay : null), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    "aria-label": Label.PREVIOUS_PAGE,
    className: "back",
    appearance: "base",
    hasIcon: true,
    disabled: currentPage === 1,
    onClick: () => handleDecrementPage(currentPage)
  }, previousButtonProps), previousButtonProps !== null && previousButtonProps !== void 0 && previousButtonProps.children ? previousButtonProps.children : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "chevron-down"
  })), showPageInput ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    id: "paginationPageInput",
    label: Label.PAGE_NUMBER,
    labelClassName: "u-off-screen",
    className: "u-no-margin--bottom pagination-input",
    onChange: handleInputPageChange,
    value: currentPage,
    type: "number"
  }), " ", typeof totalPages === "number" ? "of ".concat(totalPages) : null) : null, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    "aria-label": Label.NEXT_PAGE,
    className: "next",
    appearance: "base",
    hasIcon: true,
    disabled: currentPage === totalPages,
    onClick: () => handleIncrementPage(currentPage, totalPages)
  }, nextButtonProps), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "chevron-down"
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    className: "u-no-margin--bottom",
    label: "Items per page",
    labelClassName: "u-off-screen",
    id: "itemsPerPage",
    options: (0, _utils.generatePagingOptions)(pageLimits),
    onChange: handlePageSizeChange,
    value: pageSize
  }));
};
TablePaginationControls.propTypes = {
  displayDescription: _propTypes.default.bool,
  onInputPageChange: _propTypes.default.func,
  onNextPage: _propTypes.default.func,
  onPreviousPage: _propTypes.default.func,
  visibleCount: _propTypes.default.number,
  showPageInput: _propTypes.default.bool
};
var _default = exports.default = TablePaginationControls;